import { useState, useEffect } from 'react';

const navLinks = [
  { label: 'Über uns', href: '#about' },
  { label: 'Leistungen', href: '#services' },
  { label: 'Portfolio', href: '#portfolio' },
  { label: 'Referenzen', href: '#testimonials' },
  { label: 'Kontakt', href: '#contact' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleNav = (href: string) => {
    setMenuOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled ? 'bg-white/95 backdrop-blur-xl shadow-sm' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 h-16 flex items-center justify-between">
        {/* Logo */}
        <a href="#" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })} className="flex items-center cursor-pointer">
          <img
            src="https://public.readdy.ai/ai/img_res/74fdf9a5-9580-4fb2-84d1-9c0b79777fd0.png"
            alt="Ziersteine.de Logo"
            className="h-10 w-auto object-contain"
          />
        </a>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => (
            <button
              key={link.href}
              onClick={() => handleNav(link.href)}
              className={`text-sm font-medium tracking-wide transition-colors duration-200 cursor-pointer whitespace-nowrap ${
                scrolled ? 'text-stone-800 hover:text-stone-500' : 'text-white hover:text-white/70'
              }`}
            >
              {link.label}
            </button>
          ))}
        </nav>

        {/* CTA Button */}
        <button
          onClick={() => handleNav('#contact')}
          className={`hidden md:flex items-center gap-2 px-5 py-2 rounded-full text-sm font-medium transition-all duration-200 cursor-pointer whitespace-nowrap ${
            scrolled
              ? 'bg-stone-900 text-white hover:bg-stone-700'
              : 'bg-white/15 backdrop-blur-sm text-white border border-white/30 hover:bg-white/25'
          }`}
        >
          Beratung anfragen
          <i className="ri-arrow-right-line text-xs" />
        </button>

        {/* Mobile Hamburger */}
        <button
          className={`md:hidden cursor-pointer w-8 h-8 flex items-center justify-center ${scrolled ? 'text-stone-900' : 'text-white'}`}
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Menü öffnen"
        >
          <i className={menuOpen ? 'ri-close-line text-xl' : 'ri-menu-line text-xl'} />
        </button>
      </div>

      {/* Mobile Menu */}
      <div
        className={`md:hidden overflow-hidden transition-all duration-300 bg-white/98 backdrop-blur-xl ${
          menuOpen ? 'max-h-80 border-t border-stone-100' : 'max-h-0'
        }`}
      >
        <div className="px-6 py-4 flex flex-col gap-4">
          {navLinks.map((link) => (
            <button
              key={link.href}
              onClick={() => handleNav(link.href)}
              className="text-sm font-medium text-stone-800 hover:text-stone-500 text-left cursor-pointer transition-colors"
            >
              {link.label}
            </button>
          ))}
          <button
            onClick={() => handleNav('#contact')}
            className="mt-2 bg-stone-900 text-white rounded-full py-2 text-sm font-medium cursor-pointer whitespace-nowrap"
          >
            Beratung anfragen
          </button>
        </div>
      </div>
    </header>
  );
}
